module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point1_1-0f1c86670fa5090597b82338b52fa5f0.jpg";